import { EFieldName } from "@frameworks/NCD/Enum/OTC";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
var ProductBouquetPresenter = /** @class */ (function () {
    function ProductBouquetPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    ProductBouquetPresenter.prototype.getDownloadData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.downloadData.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.getDownloadData(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.getDraftOrders = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.draftOrders.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.getDraftOrders(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.getDraftOrderCount = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.draftOrderCount.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.getDraftOrderCount(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.userPopupStatus = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.userPopupStatus.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.userPopupStatus(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.userPopupStatusSave = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.userPopupStatusSave.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.userPopupStatusSave(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.updateBookMark = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.bookMark.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.updateBookMark(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.multiUpdateBookMark = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.multiBookMark.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.multiUpdateBookMark(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.getBookMarkList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.bookMarkList.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.getBookMark(data);
                    switch (String(req.category_code)) {
                        case ESubProductIds.Bonds:
                            return _this.actions.productBouquet.getBookMarkBonds(data);
                        case ESubProductIds.NCD:
                            return _this.actions.productBouquet.getBookMarkNcd(data);
                        case ESubProductIds.StructuredProducts:
                            return _this.actions.productBouquet.getBookMarkSp(data);
                        case ESubProductIds.UnlistedShares:
                            return _this.actions.productBouquet.getBookMarkUnlistedShares(data);
                    }
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.getProductTabs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.productTabs.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.getProductTabs(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.getProductDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.productDetails.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.getProductDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    _this.actions.productBouquet.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.getProductFilters = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.productFilters.execute({
                onSuccess: function (data) {
                    switch (req.fieldName) {
                        case EFieldName.Rating:
                            return _this.actions.productBouquet.getProductRatingFilters(data);
                        case EFieldName.InterestFrequency:
                            return _this.actions.productBouquet.getProductInterestFrequencyFilters(data);
                        case EFieldName.MaturityDate:
                            return _this.actions.productBouquet.getProductMaturityDateFilters(data);
                        case EFieldName.IssuerName:
                            return _this.actions.productBouquet.getProductIssuerNameFilters(data);
                        case EFieldName.PriceRange:
                            return _this.actions.productBouquet.getProductPriceRangeFilters(data);
                        case EFieldName.IsSecured:
                            return _this.actions.productBouquet.getProductTypeFilters(data);
                        case EFieldName.Coupon:
                            return _this.actions.productBouquet.getProductCouponFilters(data);
                        case EFieldName.MinInvestment:
                            return _this.actions.productBouquet.getMinInvestmentFilters(data);
                        case EFieldName.AvailableQuantity:
                            return _this.actions.productBouquet.getAvailableQuantityFilters(data);
                    }
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.getCashFlow = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.cashFlow.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.getCashFlow(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    ProductBouquetPresenter.prototype.getWatchList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.watchList.execute({
                onSuccess: function (data) {
                    _this.actions.productBouquet.getWatchListSchemes(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    return ProductBouquetPresenter;
}());
export default ProductBouquetPresenter;
